/**
 * SMSWiser date utilities
 * For Media Devoted | Created By Ciro Autiero
 *
 * SMSWiser date format example: "03/02/2026 08:46" (dd/mm/yyyy HH:mm)
 */

export function parseSmswiserDate(value?: string | null): Date | null {
  if (!value || typeof value !== 'string') return null;

  const match = value
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
  if (!match) return null;

  const dd = Number(match[1]);
  const mm = Number(match[2]);
  const yyyy = Number(match[3]);
  const hh = match[4] != null ? Number(match[4]) : 0;
  const min = match[5] != null ? Number(match[5]) : 0;

  return new Date(yyyy, mm - 1, dd, hh, min);
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatDdMmYyyy(date: Date): string {
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function formatDdMmYyyyHm(date: Date): string {
  return `${formatDdMmYyyy(date)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

export function formatSmswiserDate(value?: string | null): string {
  const parsed = parseSmswiserDate(value);
  if (!parsed) return value || '';
  return formatDdMmYyyyHm(parsed);
}

